import { render, staticRenderFns } from "./yeniAlis.vue?vue&type=template&id=7cbbc851&scoped=true&"
import script from "./yeniAlis.vue?vue&type=script&lang=js&"
export * from "./yeniAlis.vue?vue&type=script&lang=js&"
import style0 from "./yeniAlis.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./yeniAlis.vue?vue&type=style&index=1&id=7cbbc851&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbbc851",
  null
  
)

export default component.exports